export default {
  init() {
    // JavaScript to be fired on all pages

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired



    $('.primary-navigation .menu-item-has-children > a').hover(function(e){
      e.preventDefault();

      $('.primary-navigation .menu-item-has-children').removeClass('is-active');
      $('.primary-navigation .sub-menu').removeClass('active-sub-menu');

      $(this).parent('li').addClass('is-active');
      $(this).next('.sub-menu').addClass('active-sub-menu');


      });


    $('.top-navigation .menu-item-has-children > a').hover(function(e){
      e.preventDefault();

      $('.top-navigation .menu-item-has-children').removeClass('is-active');
      $('.top-navigation .sub-menu').removeClass('active-sub-menu');

      $(this).parent('li').addClass('is-active');
      $(this).next('.sub-menu').addClass('active-sub-menu');


    });




    $('.primary-navigation').on('mouseleave', function(){

      $('.primary-navigation .menu-item-has-children').removeClass('is-active');
      $('.primary-navigation .sub-menu').removeClass('active-sub-menu');

    });

    $('.top-navigation').on('mouseleave', function(){

      $('.top-navigation .menu-item-has-children').removeClass('is-active');
      $('.top-navigation .sub-menu').removeClass('active-sub-menu');

    });









    /*
    Mobile Nav triggers
     */

    $('.mobile-search-trigger').click(function() {
      $('.nav-search').slideToggle();
    });



    var contentLastMarginLeft = 0;
    $('.mobile-nav-trigger').click(function(){
      // $('.mobile-nav-container').slideToggle();

      $('.mobile-nav-wrap').toggleClass('is-visible');
      var box = $('.mobile-nav-container');
      var newValue = contentLastMarginLeft;
      contentLastMarginLeft = box.css('margin-left');
      box.animate({
        'margin-left': newValue,
      }, 300);
    });



    /* Mobile nav dropdowns */

    $('.mobile-navigation .menu-item-has-children > a').click(function(e){
      e.preventDefault();

      $(this).toggleClass('is-active');


      if($(this).next('.sub-menu').hasClass('active')) {
        $(this).next('.sub-menu').removeClass('active').hide();
      } else {
        $('.sub-menu.active').removeClass('active').hide();
        $(this).next('.sub-menu').toggleClass('active').show();
      }

    });



    $(window).scroll(function() {
      var scroll = $(window).scrollTop();

      if (scroll >= 130) {
        // $('body').addClass('stuck');
      } else {
        // $('body').removeClass('stuck');
      }
    });

    $('.single-image-carousel').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 5100,
      slidesToShow: 1,
      slidesToScroll: 1,
    });


    $('.logo-carousel').slick({
      dots: true,
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 6,
      slidesToScroll: 6,
      // appendArrows: $('.slick-navi'),
      // appendDots: $('.slick-navi'),
      responsive: [
        {
          breakpoint: 770,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });


    $('.content-carousel').slick({
      dots: true,
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
    });


    $('.testimonial-carousel').slick({
      dots: true,
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
    });











    $('.pager-item h5').click(function(){

      if($(this).closest('.pager-item').hasClass('active')) {
        return false;
      }

      $('.pager-item, .pager-image').removeClass('active');
      $('.pager-content').slideUp();

      var pagerId = $(this).closest('.pager-item').attr('id');

      $(this).closest('.pager-item').addClass('active');
      $(this).next('.pager-content').slideToggle();

      $('#pimg-' + pagerId).addClass('active');


    });



    $('.module-horizontals_tabs .tabs-content').children('[class^="module-"]').addClass('tabs-panel');

    $('.module-horizontals_tabs .tabs-content .tabs-panel:first-child').addClass('is-active');





    /* Smooth Scroll */
    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .not('.tabs a[href*="#"]')
      .click(function(event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
          &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top,
            }, 1000, function() {

            });
          }
        }
      });





    $('.nav-container .search-form-li').appendTo('.primary-navigation');



    $('.button').append('<span></span>');

    $('h2,h3').each(function() {
        if($(this).css('text-align') == 'center' ) {
          $(this).addClass('is-centered');
        }
    });



    $('.menu-item-has-children').click(function(){
      $(this)
    });




  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js